var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
const SvgPlus = props => /*#__PURE__*/React.createElement("svg", _extends({
  xmlns: "http://www.w3.org/2000/svg",
  fill: "none",
  viewBox: "0 0 16 16"
}, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
  fill: "currentColor",
  fillRule: "evenodd",
  d: "M8.333 7.333h5.157a.5.5 0 0 1 0 1H8.333v5.157a.5.5 0 0 1-1 0V8.333H2.176a.5.5 0 1 1 0-1h5.157V2.177a.5.5 0 0 1 1 0z",
  clipRule: "evenodd"
})));
export default SvgPlus;